import type { AxiosResponse } from 'axios';
import type { ApiResponse, PaginatedResponse, SettoreMerceologico } from '@offertify/core';
import { getApiClient } from '../configure';

export interface GetSettoriMerceologiciParams {
  page?: number;
  limit?: number;
  search?: string;
}

/** Resolve the shared transport lazily so the app can configure it at startup. */
function http() {
  return getApiClient().client;
}

/**
 * Settori merceologici endpoints (tenant-managed product sectors assignable to
 * Promozioni). Platform-agnostic (web + mobile).
 */
export const settoriMerceologiciAPI = {
  getSettori: (
    params?: GetSettoriMerceologiciParams
  ): Promise<AxiosResponse<PaginatedResponse<SettoreMerceologico>>> =>
    http().get('/settori-merceologici', { params }),

  getSettoriForSelect: (): Promise<AxiosResponse<SettoreMerceologico[]>> =>
    http().get('/settori-merceologici/select'),

  getSettore: (id: string): Promise<AxiosResponse<SettoreMerceologico>> =>
    http().get(`/settori-merceologici/${id}`),

  createSettore: (data: Partial<SettoreMerceologico>): Promise<AxiosResponse<SettoreMerceologico>> =>
    http().post('/settori-merceologici', data),

  updateSettore: (
    id: string,
    data: Partial<SettoreMerceologico>
  ): Promise<AxiosResponse<SettoreMerceologico>> => http().put(`/settori-merceologici/${id}`, data),

  // Hard-deletes PromozioneSettoreLink rows first, then soft-deletes the settore.
  deleteSettore: (id: string): Promise<AxiosResponse<ApiResponse<void>>> =>
    http().delete(`/settori-merceologici/${id}`),
};
